import request from "library/v1/request";
import { filterParams } from "utils/helpers";

export function appointments(params) {
  return request({
    url: `/appointments`,
    method: 'get',
    params: filterParams(params),
    cancelPrevious: true
  });
}

export function appointment(id) {
  return request({
    url: `/appointments/${id}`,
    method: 'get'
  });
}

export function updateAppointment(id, actionType) {
  return request({
    url: `/appointments/${id}/${actionType}`,
    method: 'post'
  });
}

export function fetchAppointments() {
  return request({
    url: `appointments/fetch_appointments`,
    method: 'get',
  });
}

export function getPatientAppointments(params) {
  return request({
    url: `appointments/patient_appointments`,
    method: 'get',
    params: params
  });
}
